import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import moment from "moment";
import "../../../Assets/Styles/component.css";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import { commonService } from "../../../utils/commonService";
import Loader from "../../Loader/Loader";

const GroupBlocksOnHighDemandDates = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    GroupBlocksOnHighDemandDatesTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const getGroupBlockData = async () => {
    setLoading(true);

    let grpBlockResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MORNING_BRIEFING.GET_HIGH_DEMAND_GROUP,
        body: {
          propertyCode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
          asofdate: para?.asOfDate,
        },
      },
      false,
    );

    let response = apiResponse(false, grpBlockResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data || [];
      setData(dataFromApi);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      const startDateStr = moment(para?.asOfDate || new Date()).format("YYYY-MM-DD");
      const endDateStr = moment(para?.asOfDate || new Date()).add(3, "days").format("YYYY-MM-DD");
      const staticData = [
        {
          groupname: "Tech Summit Group",
          arrivaldate: startDateStr,
          departuredate: endDateStr,
          rms: 45,
          grouprate: 160,
          transientadr: 210,
          forecast_occ: 88,
          displacement_revenue: 2250,
        },
        {
          groupname: "Global Healthcare Block",
          arrivaldate: moment(startDateStr).add(5, "days").format("YYYY-MM-DD"),
          departuredate: moment(startDateStr).add(8, "days").format("YYYY-MM-DD"),
          rms: 30,
          grouprate: 175,
          transientadr: 195,
          forecast_occ: 82,
          displacement_revenue: 1100,
        },
      ];
      setData(staticData);
      setLoading(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getGroupBlockData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  const formatDateRange = (arrival, departure) => {
    if (!arrival) return "";
    const parseDate = (d) => {
      const parts = d.split("-");
      const date = new Date(parts[0], parts[1] - 1, parts[2]);
      return {
        month: date.toLocaleString("default", { month: "short" }),
        day: date.getDate(),
      };
    };
    const arr = parseDate(arrival);
    const dep = departure ? parseDate(departure) : arr;

    if (arrival === departure) return `${arr.month} ${arr.day}`;
    if (arr.month === dep.month) return `${arr.month} ${arr.day}-${dep.day}`;
    return `${arr.month} ${arr.day} - ${dep.month} ${dep.day}`;
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "GroupBlocksOnHighDemandDates",
                "emailIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.GroupBlocksOnHighDemandDatesTable,
                  "GroupBlocksOnHighDemandDates",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId,
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "GroupBlocksOnHighDemandDates",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName:
                    compName?.GroupBlocksOnHighDemandDates ||
                    "GroupBlocksOnHighDemandDates",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "GroupBlocksOnHighDemandDates",
                "downloadIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.GroupBlocksOnHighDemandDatesTable}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.GroupBlocksOnHighDemandDatesTable,
                  `${para?.propertyCode}-GroupBlocksOnHighDemandDates-${moment(new Date()).format("MMDDYYYY")}`,
                )
              }
            />
          </Button>
        </div>
      )}

      <div className="ViewPropertySetupTable mainTableClass">
        <div className="stripped__table">
          <div className="table-responsive tblDynamicPickupSticky mb-3">
            <Table
              id={tblids.GroupBlocksOnHighDemandDatesTable}
              hover
              className="table-with-spacing positionStaticTable dailySummaryTbl"
            >
              <thead className="tbl-header-sticky">
                <tr className="diff-bg-tr">
                  <th className="border-right">Block</th>
                  <th className="border-right ">Dates</th>
                  <th className="border-right text-center">RMS</th>
                  <th className="border-right text-end">Blk Rate</th>
                  <th className="border-right text-end">Trans ADR Trend</th>
                  <th className="border-right text-center">FC Occ</th>
                  <th className="border-right text-end">Displaced Rev</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center py-4 relative-loader"
                    >
                      <Loader />
                    </td>
                  </tr>
                ) : data && data.length > 0 ? (
                  data.map((row, index) => {
                    // const isHighRisk = Number(row.displacement_revenue) < -1000;
                    return (
                      <tr
                        key={index}
                        // className={
                        //   isHighRisk ? "morning-briefing-row-high-risk" : ""
                        // }
                      >
                        <td className="border-right">{row.groupname}</td>
                        <td className="border-right">
                          {formatDateRange(row.arrivaldate, row.departuredate)}
                        </td>
                        <td className="border-right text-center">{row.rms}</td>
                        <td className="border-right text-end">
                          {commonService.formateAmount(row.grouprate)}
                        </td>
                        <td className="border-right text-end">
                          {commonService.formateAmount(row.transientadr)}
                        </td>
                        <td className="border-right text-center">
                          {row.forecast_occ}%
                        </td>
                        <td className={`border-right text-end`}>
                          {commonService.formateAmount(
                            Math.abs(row.displacement_revenue),
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={
            "GroupBlocksOnHighDemandDates" +
            tblids.GroupBlocksOnHighDemandDatesTable
          }
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default GroupBlocksOnHighDemandDates;
